import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/.pnpm/next@15.5.9_@babel+core@7.29.0_@opentelemetry+api@1.9.0_@playwright+test@1.58.0_react-dom@19.2.3_react@19.2.3/node_modules/next/dist/client/app-dir/link.js");
